import { OrgMembership } from '../types/admin';

interface Props {
  memberships: OrgMembership[];
  onContinue: () => void;
}

const ROLE_LABEL: Record<OrgMembership['role'], string> = {
  admin: 'Admin',
  estimator: 'Estimator',
  mover: 'Mover',
  dispatcher: 'Dispatcher',
  field_lead: 'Field Lead',
};

export function InvitationWelcomePage({ memberships, onContinue }: Props) {
  const isSingle = memberships.length === 1;

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-start pt-16 px-6 pb-12">
      <div className="w-full max-w-sm flex flex-col gap-8">

        {/* Icon */}
        <div className="flex justify-center">
          <div className="w-20 h-20 rounded-full bg-plum/10 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-10 h-10 text-plum"
              aria-hidden="true"
            >
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
        </div>

        {/* Heading */}
        <div className="text-center flex flex-col gap-2">
          <h1 className="font-display text-h2 text-midnight leading-tight">
            {isSingle ? "You're In!" : "You've Been Added"}
          </h1>
          <p className="text-body text-slate">
            {isSingle
              ? "You've been added to an organization and are ready to start estimating."
              : "You've been added to the following organizations."}
          </p>
        </div>

        {/* Org list */}
        <div className="flex flex-col gap-3">
          {memberships.map(m => (
            <div
              key={m.orgId}
              className="rounded-xl border border-stone bg-mist px-5 py-4 flex items-center justify-between gap-4"
            >
              <div className="flex flex-col gap-0.5 min-w-0">
                <p className="text-sm font-semibold text-midnight truncate">{m.orgName}</p>
                <p className="text-sm text-slate">Role: {ROLE_LABEL[m.role]}</p>
              </div>
              <span className="shrink-0 inline-flex items-center rounded-full bg-plum/10 px-3 py-1 text-xs font-semibold text-plum">
                {ROLE_LABEL[m.role]}
              </span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <button
          type="button"
          onClick={onContinue}
          className="btn-primary w-full mt-2"
        >
          Continue to App
        </button>

      </div>
    </div>
  );
}
